import React, { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import DemonEye from "@/components/DemonEye";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { motion } from "framer-motion";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    const res = await login(email.trim(), password);
    setBusy(false);
    if (res.ok) navigate("/dashboard");
    else setError(res.error || "Nieprawidłowy e-mail lub hasło.");
  };

  return (
    <div className="demon-bg min-h-screen flex items-center justify-center px-4 relative overflow-hidden">
      <div className="grid-overlay absolute inset-0 opacity-30" />
      <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full bg-violet-700/10 blur-[120px]" />

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="glass rounded-3xl p-8 sm:p-10 w-full max-w-md relative z-10"
      >
        <div className="flex flex-col items-center text-center mb-8">
          <DemonEye size={72} className="animate-eye mb-4" />
          <h1 className="font-display text-3xl font-extrabold tracking-tight text-glow">THE MONEY CLUB</h1>
          <div className="text-[11px] tracking-[0.35em] text-demon-muted mt-1">92 DAYS CHALLENGE</div>
          <p className="text-demon-muted text-sm mt-4">Zaloguj się do swojego panelu</p>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="text-xs tracking-widest text-demon-muted">E-MAIL</Label>
            <Input
              data-testid="login-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="twoj@email.com"
              className="mt-1.5 bg-black/50 border-violet-900/40 h-12 text-white focus-visible:ring-violet-500"
              required
            />
          </div>
          <div>
            <Label className="text-xs tracking-widest text-demon-muted">HASŁO</Label>
            <Input
              data-testid="login-passcode-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="mt-1.5 bg-black/50 border-violet-900/40 h-12 text-white focus-visible:ring-violet-500"
              required
            />
          </div>

          {error && (
            <div data-testid="login-error" className="text-red-400 text-sm text-center bg-red-500/10 border border-red-500/30 rounded-lg py-2">
              {error}
            </div>
          )}

          <Button
            data-testid="login-submit-button"
            type="submit"
            disabled={busy}
            className="w-full h-12 text-base font-display font-semibold tracking-wide bg-gradient-to-r from-violet-700 to-violet-500 hover:from-violet-600 hover:to-violet-400 border-0 shadow-[0_0_24px_rgba(168,85,247,0.4)]"
          >
            {busy ? <Loader2 className="animate-spin" size={18} /> : "ZALOGUJ SIĘ"}
          </Button>
        </form>

        <div className="text-center mt-6">
          <Link to="/" className="text-demon-muted text-xs hover:text-violet-400">
            ← Powrót do strony głównej
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
